module.exports = "<footer>\n  <div class=\"footer-bottom pt-1 pb-1 api-info\">{{footerinfo}}</div>\n</footer>"